import React, { FC } from 'react'
import { Button } from '@/atoms/Button'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { Image } from '@/atoms/Image'
import { HeadingMD, ParagraphMD, ParagraphSM, TitleLG } from '@/atoms/Text'
import { Modal } from '@/molecules/Modal'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  open: boolean
  onClose: () => void
}
export const DavidGiveawayModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslate('tickets')

  const title = t('buyTicketsForDavidToWin', 'Buy Tickets for DAVID and Enter to Win a $60K Trip to the Holy Land!')

  const description = t(
    'davidEnterToWinDescription',
    'See DAVID in theaters December 19th and enter to win a breathtaking trip to the Holy Land. Walk in the footsteps of King David with this unforgettable adventure!',
  )

  return (
    <Modal
      backgroundScreenColor="black"
      isOpen={open}
      onClose={onClose}
      panelClasses="w-full !max-w-[361px] md:!max-w-[600px] !bg-[#141721] shadow-dark-4 rounded-3xl !p-0 relative text-left"
      transition="appear"
      className="z-[99999]"
      childWrapperClassName="!m-0"
    >
      <div className="relative h-[200px] w-full rounded-t-2xl md:h-[300px]">
        <Image
          src="/v1762312304/david/david-giveaway-image"
          alt="David and family"
          fill
          className="rounded-t-2xl object-cover"
        />
      </div>

      <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-white p-[10px]" onClick={onClose}>
        <CloseIcon color="core-gray-950" size={20} />
      </div>

      <div className="relative z-40 rounded-b-3xl p-6 md:p-10">
        <TitleLG weight="bold" className="!text-[#F1B420] sm:hidden">
          {title}
        </TitleLG>
        <HeadingMD weight="bold" className="hidden !text-[#F1B420] sm:block">
          {title}
        </HeadingMD>

        <ParagraphSM color="white" className="mt-4 sm:hidden">
          {description}
        </ParagraphSM>
        <ParagraphMD color="white" className="mt-4 hidden sm:block">
          {description}
        </ParagraphMD>

        <Button className="mr-auto mt-6 w-fit sm:mt-8" variant="white" onClick={onClose}>
          {t('getShowtimes', 'Get Showtimes')}
        </Button>
      </div>
    </Modal>
  )
}
